'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reduxImmutable = require('redux-immutable');

var _measurementsMapReducer = require('./measurementsMapReducer');

var _measurementsMapReducer2 = _interopRequireDefault(_measurementsMapReducer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Lib
exports.default = (0, _reduxImmutable.combineReducers)({
    measurements: _measurementsMapReducer2.default
});

// Reducers


//////////////////
// WEBPACK FOOTER
// ./src/client/components/measurements/store/reducers/index.js
// module id = 1912
// module chunks = 0